__turbopack_context__.v({
  "alignmentContainer": "TrustpilotWidget-module__ZU3IzG__alignmentContainer",
  "alignmentWrapper": "TrustpilotWidget-module__ZU3IzG__alignmentWrapper",
  "leftAlign": "TrustpilotWidget-module__ZU3IzG__leftAlign",
  "microcombo": "TrustpilotWidget-module__ZU3IzG__microcombo",
});
